module.exports = __webpack_public_path__ + "assets/img/pageHead.808109bf.png";